import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminApi, clearAdminToken, getAdminToken } from "../../lib/adminApi";

/** Auth wrapper — call GET /admin/me to validate token on mount. If missing or
 *  invalid, redirect to /admin/login preserving the intended path. */
export default function AdminGate({ children }) {
  const [status, setStatus] = useState("checking"); // 'checking' | 'ok'
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const token = getAdminToken();
    if (!token) {
      nav("/admin/login", { replace: true, state: { from: loc.pathname } });
      return;
    }
    let ignore = false;
    adminApi
      .get("/admin/me")
      .then(() => !ignore && setStatus("ok"))
      .catch(() => {
        if (ignore) return;
        clearAdminToken();
        nav("/admin/login", { replace: true, state: { from: loc.pathname } });
      });
    return () => {
      ignore = true;
    };
  }, [nav, loc.pathname]);

  if (status === "checking") {
    return (
      <div
        className="min-h-screen flex items-center justify-center text-hbe-ink/50"
        data-testid="admin-gate-loading"
      >
        <div>Checking session…</div>
      </div>
    );
  }
  return children;
}
